// // store index.js

import {getToken,setToken,setUserInfo,getUserInfo,getCookieValue,setCookieValue} from '@/utils/auth'
import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex);

const state = {
  user: getUserInfo(),
  token: getToken(),
  loginPopStatus: false,
  loginStatus: getToken() && !!getToken() ? true : false,
  openId: false,
  paymentCode: getCookieValue('paymentCode'),
}

const mutations = {
  SET_TOKEN: (state,data) => {
    state.token = data.token;
    setToken(data.token,data.isAutoLogin);
  },
  GET_USER: (state,data) => {
    state.user = data;
    setUserInfo(data);
  },
  LOGIN: (state,data) => {
    state.loginStatus = data;
  },
  LOGINPOPWIN: (state,data) => {
    state.loginPopStatus = data;
  },
  LOGOUT: (state) => {
    state.token = false;
    state.user = false;
    state.loginStatus = false;
    setToken(false);
    setUserInfo(false);
  },
  SET_OPEN_ID: (state,data) => {
    state.openId = data;
  },
  SET_PAYMENT_CODE: (state,data)=>{
    state.paymentCode = data;
    setCookieValue('paymentCode',data);
  }
}

const actions = {}

export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js